<ng-container *ngIf="columnLength?.length > 0">
  <div class="w-full border p-3" *ngIf="data?.length > 0; else empty">
    <div class="border-b-2 mb-2" fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayout="row">
        <h4 class="text-primary"><b>{{displayName}}</b></h4>
      </div>
      <button type="button" class="mb-2" (click)="ViewTableFullScreen()">
        <mat-icon class="dynamic-form-table-icon" [icIcon]="icAllOut" align="end">
        </mat-icon>
      </button>
    </div>
    <vex-scrollbar [@stagger]="true" class="flex-auto" [ngStyle]="{'max-height': tabHeight}">
      <table attr.id="{{name}}_table" class="w-full mat-table resizable">
        <thead>
            <tr class="mat-header-row text-left">
              <th class="uppercase mat-header-cell sticky bg-white">#</th>
              <ng-container *ngFor="let type of rowAttributes">
                <ng-container *ngIf="type.DataGeneratedBy=='User' || (type.DataGeneratedBy=='CSP' && type.IsParentProperty == true)">
                  <th class="uppercase mat-header-cell">
                    {{type.DisplayName}}
                  </th>
                </ng-container>
              </ng-container>
            </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="data && data.length > 0; else showNone">
            <ng-container *ngFor="let item of data;let i = index;let odd=odd; trackBy : trackByListId">
              <tr class="mat-row" [ngClass]="{'bg-row-color': odd}">
                <td class="mat-cell" [ngClass]="{'bg-row-color': odd, 'bg-white': !odd}">{{i+1}}</td>
                <ng-container *ngFor="let type of rowAttributes;">
                  <ng-container *ngIf="type.DataGeneratedBy=='User' || (type.DataGeneratedBy=='CSP' && type.IsParentProperty == true)">
                    <td style="cursor: pointer;" class="mat-cell word-break">
                      {{ item['display_' + type.Name] }}
                    </td>
                  </ng-container>
                </ng-container>
              </tr>
            </ng-container>
          </ng-container>
          <ng-template #showNone>
            <tr class="mat-row">
              <b>N/A</b>
            </tr>
          </ng-template>
        </tbody>
      </table>
    </vex-scrollbar>
  </div>
  <ng-template #empty>
    <div fxFlex>
      <span class="primary leading-normal">
        {{displayName}}
      </span>: 
      <span class="flex-auto text-sm leading-normal font-semibold text-black">N/A</span>
    </div>
  </ng-template>
</ng-container>